import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CartService } from 'src/app/services/cart.service';
import { faTag, faCircleCheck, faCircleX } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-dialog-promo-code',
  templateUrl: './dialog-promo-code.component.html',
  styleUrls: ['./dialog-promo-code.component.scss'],
})
export class DialogPromoCodeComponent {
  faTag = faTag;
  faCircleCheck = faCircleCheck;
  faCircleX = faCircleX;

  code: string = '';
  validating: boolean = false;
  applying: boolean = false;
  preview: any = null;
  error: string = '';

  constructor(
    private cartService: CartService,
    private dialogRef: MatDialogRef<DialogPromoCodeComponent>
  ) {}

  validate() {
    const code = this.code.trim();
    if (!code) return;
    const cartId = this.cartService.getCartId();
    if (!cartId) return;

    this.error = '';
    this.preview = null;
    this.validating = true;

    this.cartService.validatePromoCode(cartId, code).subscribe({
      next: (res) => {
        this.validating = false;
        if (res?.valid) {
          this.preview = res.discount;
        } else {
          this.error = this.mapError(res?.message);
        }
      },
      error: (err) => {
        this.validating = false;
        this.error = this.mapError(err?.error?.message);
      }
    });
  }

  apply() {
    const code = this.code.trim();
    if (!code) return;
    const cartId = this.cartService.getCartId();
    if (!cartId) return;

    this.error = '';
    this.applying = true;

    this.cartService.applyPromoCode(cartId, code).subscribe({
      next: (res) => {
        this.applying = false;
        this.dialogRef.close({ applied: true, code, discount: res?.cart?.discount_total || 0 });
      },
      error: (err) => {
        this.applying = false;
        this.error = this.mapError(err?.error?.message);
      }
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  private mapError(message: string): string {
    const map: { [key: string]: string } = {
      'Invalid or inactive promo code': 'El código no existe o está desactivado.',
      'Promo code discount is not active or expired': 'El código está fuera de su periodo de validez.',
      'Promo code has reached its maximum uses': 'El código ha alcanzado el número máximo de usos.',
      'Promo code is not valid for this sales channel': 'El código no es válido para el TPV.',
      'You have reached the limit of uses for this promo code': 'Ya has alcanzado el límite de usos de este código.',
    };
    return map[message] || 'El código no es válido.';
  }

  formatNumber(value: number): string {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, style: 'currency', currency: 'EUR' }).format(value);
  }
}
